import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser]       = useState(null);
    const [token, setToken]     = useState(() => sessionStorage.getItem('admin_token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token) { setLoading(false); return; }
        fetch(`${API_BASE}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
            .then(r => r.ok ? r.json() : Promise.reject())
            .then(u => {
                if (!u.isSuperAdmin) {
                    sessionStorage.removeItem('admin_token');
                    setToken(null);
                    setUser(null);
                } else {
                    setUser(u);
                }
            })
            .catch(() => {
                sessionStorage.removeItem('admin_token');
                setToken(null);
            })
            .finally(() => setLoading(false));
    }, [token]);

    const login = async (email, password) => {
        const res = await fetch(`${API_BASE}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ email, password }),
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body.message || 'Identifiants invalides');
        }
        const data = await res.json();
        const t = data.token;
        if (!data.user?.isSuperAdmin) throw new Error('Accès réservé aux super administrateurs');
        sessionStorage.setItem('admin_token', t);
        setToken(t);
        setUser(data.user);
    };

    const loginWithToken = (t, u) => {
        sessionStorage.setItem('admin_token', t);
        setToken(t);
        setUser(u);
    };

    const logout = () => {
        sessionStorage.removeItem('admin_token');
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, loading, login, loginWithToken, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
